import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';

import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import removeDiactritics from 'common/app/removeDiacritics';

export const AutoCompleteField = ({ getSuggestionValue, inputProps, classNameProp, listToFilter }) => {
  const [suggestions, setSuggestions] = useState([]);

  const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const getSuggestions = (v) => {
    const escapedValue = escapeRegexCharacters(removeDiactritics(v.trim()));

    if (!escapedValue || escapedValue.length < 3) {
      return [];
    }

    const regex = new RegExp(escapedValue, 'i');
    return listToFilter.filter(s => (regex.test(s.searchName) || regex.test(s.mic)));
  };

  const renderSuggestion = (suggestion, { query }) => {
    const allExchangeMatches = match(suggestion.exchangeName, query, { insideWords: true });

    let highlighted = false;
    let lastHighlightedLetterPosition = -1;
    const exchangeMatches = [];
    if (allExchangeMatches && allExchangeMatches[0]) {
      exchangeMatches.push(allExchangeMatches[0]);

      highlighted = true;
      const [exchangeMatch,] = allExchangeMatches;
      [, lastHighlightedLetterPosition] = exchangeMatch;
    }

    if (highlighted && allExchangeMatches.length > 1) {
      allExchangeMatches.slice(1).forEach((m) => {
        if (highlighted && lastHighlightedLetterPosition === (m[0] - 1)) {
          exchangeMatches.push(m);
        } else {
          highlighted = false;
        }

        [, lastHighlightedLetterPosition] = m;
      });
    }

    const exchangeParts = parse(suggestion.exchangeName, exchangeMatches);

    const bracketedMic = ` (${ suggestion.mic })`;
    let micParts;
    if (highlighted === true) {
      micParts = [{ text: bracketedMic, highlight: false }];
    } else {
      const micMatches = match(bracketedMic, query, { insideWords: true });
      micParts = parse(bracketedMic, micMatches);
    }

    const parts = [...exchangeParts || [], ...micParts || []];
    return (
      <span>
        {
            // eslint-disable-next-line arrow-body-style
            parts.map((part, index) => {
              return (part.highlight ? <span className="text-highlight">{part.text}</span> : <span>{part.text}</span>
              );
            })
        }
      </span>
    );
  };

  const onSuggestionsFetchRequested = e => setSuggestions(getSuggestions(e.value));
  const onSuggestionsClearRequested = () => setSuggestions([]);

  return (
    <Autosuggest
      suggestions={ suggestions }
      onSuggestionsFetchRequested={ onSuggestionsFetchRequested }
      onSuggestionsClearRequested={ onSuggestionsClearRequested }
      getSuggestionValue={ getSuggestionValue }
      renderSuggestion={ renderSuggestion }
      inputProps={ inputProps }
      theme={ {
        container: 'react-autosuggest__container',
        containerOpen: 'react-autosuggest__container--open',
        input: classNameProp,
        inputOpen: 'react-autosuggest__input--open',
        inputFocused: 'react-autosuggest__input--focused',
        suggestionsContainer: 'react-autosuggest__suggestions-container',
        suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
        suggestionsList: 'react-autosuggest__suggestions-list scrollable',
        suggestion: 'react-autosuggest__suggestion',
        suggestionFirst: 'react-autosuggest__suggestion--first',
        suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
        sectionContainer: 'react-autosuggest__section-container',
        sectionContainerFirst: 'react-autosuggest__section-container--first',
        sectionTitle: 'react-autosuggest__section-title'
      } }
    />
  );
};

AutoCompleteField.propTypes = {
  getSuggestionValue: PropTypes.func.isRequired,
  inputProps: PropTypes.shape().isRequired,
  classNameProp: PropTypes.string.isRequired,
  listToFilter: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default AutoCompleteField;
